import { combineReducers } from 'redux';

import slices from './slices';

export const reducers = {
  plans: slices.plansSlice.reducer,
  enrollments: slices.enrollmentsSlice.reducer,
};

const reducer = combineReducers({
  plans: reducers.plans,
  enrollments: reducers.enrollments,
});

export default reducer;
